import { PaymentMethod } from '../constants';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getEmptyOfferCategory = (_type) => {
    const emptyList = [];
    return {
        [PaymentMethod.cash]: emptyList,
        [PaymentMethod.lease]: emptyList,
        [PaymentMethod.finance]: emptyList,
    };
};
export default function mapOffersToTrims(trims, offers) {
    const offersMap = offers.reduce((map, offer) => {
        if (!offer.transmissionKey)
            return map;
        map.set(offer.transmissionKey, offer);
        return map;
    }, new Map());
    return trims.map(trim => {
        var _a, _b, _c;
        const trimOffer = offersMap.get(trim.transmissionKey);
        return {
            ...trim,
            offers: {
                loyaltyOffers: (_a = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.loyaltyOffers) !== null && _a !== void 0 ? _a : getEmptyOfferCategory('loyaltyOffers'),
                incentiveOffers: (_b = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.incentiveOffers) !== null && _b !== void 0 ? _b : getEmptyOfferCategory('incentiveOffers'),
                specialRateOffers: (_c = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.specialRateOffers) !== null && _c !== void 0 ? _c : getEmptyOfferCategory('specialRateOffers'),
                bonusOffers: trim.financials.bonusOffers.reduce((offerGroups, offer) => {
                    var _a;
                    return ({
                        ...offerGroups,
                        [offer.paymentMethod]: (_a = offer.offers) !== null && _a !== void 0 ? _a : [],
                    });
                }, {}),
            },
        };
    });
}
